export const messages = {
  en: {
    allocationUserStorehouseManage: {
      search: {
        title: 'Search Conditions',
        ausId: 'Please enter allocation ID',
        resId: 'Please enter resource ID',
        resName: 'Please enter resource name',
        parentRstId: 'Please select resource type',
        rstId: 'Please select secondary category',
        rssId: 'Please select specification',
        startUserId: 'Please enter donor ID',
        startUserName: 'Please enter donor name',
        acceptUserId: 'Please enter recipient ID',
        acceptUserName: 'Please enter recipient name',
        startTime: 'Please select start time',
        endTime: 'Please select end time'
      },
      list: {
        title: 'Allocation Records'
      },
      table: {
        ausId: 'Allocation ID',
        resId: 'Resource ID',
        resType: 'Resource Type',
        resName: 'Resource Name',
        specName: 'Specification',
        isFixedName: 'Fixed Resource',
        startUserId: 'Donor ID',
        startUserName: 'Donor',
        acceptUserId: 'Recipient ID',
        acceptUserName: 'Recipient',
        stock: 'Original Stock',
        giveQuantity: 'Allocation Quantity',
        createTime: 'Create Time',
        remark: 'Remark'
      },
      total: {
        subTotal: 'Subtotal',
        highTotal: 'Total',
        quantity: 'Total Quantity:'
      },
      exportSuccess: 'Export started successfully',
      exportFailed: 'Export failed'
    }
  },
  zh: {
    allocationUserStorehouseManage: {
      search: {
        title: '查询条件',
        ausId: '请输入转增ID',
        resId: '请输入物品资源ID',
        resName: '请输入物品名称',
        parentRstId: '请选择物品类型',
        rstId: '请选择二级分类',
        rssId: '请选择物品规格',
        startUserId: '请输入转增人ID',
        startUserName: '请输入转增人名称',
        acceptUserId: '请输入转增对象ID',
        acceptUserName: '请输入转增对象名称',
        startTime: '请选择开始时间',
        endTime: '请选择结束时间'
      },
      list: {
        title: '转赠记录'
      },
      table: {
        ausId: '转增ID',
        resId: '物品资源ID',
        resType: '物品类型',
        resName: '物品名称',
        specName: '物品规格',
        isFixedName: '固定物品',
        startUserId: '转赠人ID',
        startUserName: '转赠人',
        acceptUserId: '转赠对象ID',
        acceptUserName: '转赠对象',
        stock: '原有库存',
        giveQuantity: '转赠数量',
        createTime: '创建时间',
        remark: '备注'
      },
      total: {
        subTotal: '小计',
        highTotal: '大计',
        quantity: '总数量：'
      },
      exportSuccess: '导出开始成功',
      exportFailed: '导出失败'
    }
  }
}